export enum EVisitType {
    TextVisit = 1,
    PhoneVisit = 2,
    VideoVisit = 3,
    BodyVisit = 4
}